import styles from './Notifications.module.css'
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../../auth/auth";
import { getWorkersFromJob, sendCustomPushNotification } from "../../../../../api/apiCall";
import { Button, Checkbox, CircularProgress, TextField } from "@mui/material";
import { toast } from "react-toastify";

const Notifications = ({id}: any) => {
    const {state} = useAuth();
    const [selectedWorkers, setSelectedWorkers] = useState<any[]>([])
    const [workers, setWorkers] = useState<any[]>([]);
    const [title, setTitle] = useState<any>('');
    const [desc, setDesc] = useState<any>('');
    const [loading, setLoading] = useState(false);
    
    const getWorkers = async () => {
        try {
            const response = await getWorkersFromJob(state.user?.token, id);
            if (response && Array.isArray(response)) {
                setWorkers(response);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getWorkers();
    }, []);

    const onChange = (e: any, workerId: any) => {
        if (e.target.checked) {
            setSelectedWorkers(prevWorkers => [...prevWorkers, workerId]);
        } else {
            setSelectedWorkers(prevWorkers => prevWorkers.filter(w => w !== workerId));
        }
    };

    const handleSelectAll = (e: any) => {
        const checked = e.target.checked;
        if (checked) {
            const allWorkerIds = workers.filter(w => w.userId).map(w => w.userId);
            setSelectedWorkers(allWorkerIds);
        } else {
            setSelectedWorkers([]);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        const response: any = await sendCustomPushNotification(state.user?.token, title, desc, selectedWorkers);

        if(response?.status === 200) {
            toast.success('Push Notification sent');
            setTitle('');
            setDesc('');
        } else {
            toast.error('Something went wrong')
        }
        setLoading(false);
    }

    const isButtonDisabled = selectedWorkers.length === 0 || title.trim() === '' || desc.trim() === '';
    const validWorkers = workers.filter(w => w.userId);

    return (
        <>
            <div className={styles.tableContainer}>
                {validWorkers.length > 0 ? (
                    <>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th><Checkbox onChange={handleSelectAll} /></th>
                                    <th>ROLE</th>
                                    <th>NAME</th>
                                    <th>PTS</th>
                                    <th>PHONE NUMBER</th>
                                    <th>POST CODE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {validWorkers.map((worker: any) => (
                                    <tr key={worker.id}>
                                        <td>
                                            <Checkbox
                                                onChange={(e) => onChange(e, worker.userId)}
                                                checked={selectedWorkers.includes(worker.userId)}
                                            />
                                        </td>
                                        <td>{worker.workRole}</td>
                                        <td>{worker.fullName}</td>
                                        <td>{worker.pts}</td>
                                        <td>{worker.phoneNumber}</td>
                                        <td>{worker.postCode}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                ) : (
                  <div className={styles.noWorkersText}>
                      No workers.
                  </div>
                )}
            </div>
            {validWorkers.length > 0 && (
                <div className={styles.form}>
                    <TextField
                        label={"Title"}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <TextField
                        label={"Description"}
                        multiline
                        rows={5}
                        value={desc}
                        onChange={(e) => setDesc(e.target.value)}
                    />
                    <Button
                        variant="contained"
                        size="medium"
                        onClick={handleSubmit}
                        disabled={isButtonDisabled || loading}
                        style={{backgroundColor: '#1669c5', boxShadow: 'none', color: 'white'}}
                    >
                        {loading? <CircularProgress size={25} style={{color: 'white'}} /> : "Send Notification"}</Button>
                </div>
            )}
        </>
    )
}

export default Notifications;
